export const seasonOptions = ["Spring", "Summer", "Autumn", "Winter"];

export function themeColor(theme) {
  switch (theme) {
    case "Nature":
      return "success";
    case "History":
      return "warning";
    case "Food":
      return "info";
    case "Adventure":
      return "danger";
    case "Sea":
      return "primary";
    case "Culture":
      return "default";
    default:
      return "secondary";
  }
}

export function sortByOption(items, option, custom = {}) {
  const next = [...items];

  switch (option) {
    case "name-asc":
      next.sort((left, right) => String(left.name || "").localeCompare(String(right.name || ""), "tr"));
      return next;
    case "name-desc":
      next.sort((left, right) => String(right.name || "").localeCompare(String(left.name || ""), "tr"));
      return next;
    case "title-asc":
      next.sort((left, right) => String(left.title || "").localeCompare(String(right.title || ""), "tr"));
      return next;
    case "title-desc":
      next.sort((left, right) => String(right.title || "").localeCompare(String(left.title || ""), "tr"));
      return next;
    case "updated-desc":
      next.sort((left, right) => String(right.updatedAt || "").localeCompare(String(left.updatedAt || "")));
      return next;
    case "updated-asc":
      next.sort((left, right) => String(left.updatedAt || "").localeCompare(String(right.updatedAt || "")));
      return next;
    default:
      if (typeof custom[option] === "function") {
        next.sort(custom[option]);
      }
      return next;
  }
}

export function toDateLabel(value) {
  if (!value) return "-";
  return value;
}

export function normalizeSlug(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/ç/g, "c")
    .replace(/ğ/g, "g")
    .replace(/ı/g, "i")
    .replace(/ö/g, "o")
    .replace(/ş/g, "s")
    .replace(/ü/g, "u")
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

export function confirmAdminAction(subject, actionText = "arşive alınsın mı?") {
  return window.confirm(`${subject} ${actionText}`);
}